import adapter from './adapter'
import { collectionGetters } from '@/store/collection'
import { User } from './model'

const { getAll, getCollection, itemGetter } = collectionGetters(adapter, {
  constructor: data => new User(data)
})

export default {
  getAll,
  getCollection,
  getUser: itemGetter,
}
